import { AccountId, PaymentMethodType } from "..";
import { OrgId } from "./Org.schema";

export enum TryoutVisibility {
  coachesOnly = "coachesOnly",
  allTeamStaff = "allTeamStaff"
}

// Use this collection for settings that don't need to be accessed very often
export interface OrgSettings {
  id: OrgId;
  primaryColor?: string;
  defaultReplyToEmailAddress?: string;
  websiteUrl?: string;
  socialUrls?: {
    facebookUrl?: string;
    instagramUrl?: string;
    twitterUrl?: string;
  };
  tryoutSettings?: {
    defaultReplyToEmailAddress?: string;
    defaultOfferEmailText?: string;
    defaultRejectionEmailText?: string;
    defaultOfferExpirationTimeInHrs?: number;
    confirmationEmailMessage?: string;
    enableRestrictedTryoutMode?: boolean;
    tryoutVisibility?: TryoutVisibility;
    additionalAccountsWithTryoutAccess?: Record<AccountId, true | undefined>;
  };
  campSettings?: {
    defaultReplyToEmailAddress?: string;
    confirmationEmailMessage?: string;
    enableRestrictedCampMode?: boolean;
  };
  genericEventSettings?: {
    defaultReplyToEmailAddress?: string;
    confirmationEmailMessage?: string;
    enableRestrictedGenericEventMode?: boolean;
  };
  registrationSettings?: {
    defaultReplyToEmailAddress?: string;
    restrictAdditionalStepsToAdmins?: boolean;
    incompleteRegistrationNotifications?: {
      orgAdmins?: boolean;
      teamAdmins?: boolean;
      coaches?: boolean;
      individuals?: boolean;
    };
  };
  customFeeDetails?: Record<PaymentMethodType, OrgFeeDetails>;
  fieldSchedulerEnabled?: boolean;
  ageGroupLabels?: Record<string, string>; // e.g. { "U4": "9/1/2022 - 8/31/2023", "U5": "9/1/2021 - 8/31/2022" }
}

export type OrgFeeDetails = {
  percent: number; // Between 1 and 100. For example, 3.5% should be 3.5
  flatAmountCents: number;
};
